import * as Sentry from '@sentry/browser'
import { CaptureConsole } from '@sentry/integrations'
import { Integrations } from '@sentry/tracing'
import { createRoot } from 'react-dom/client'

import { App } from './app'

const { NODE_ENV, SOURCE_VERSION } = process.env

Sentry.init({
  release: `rebla-zo@${SOURCE_VERSION}`,
  dsn: 'https://122d6fbf70bd443ca77f9169c1e4a772@sentry.io/2300119',
  integrations: [
    new CaptureConsole({ levels: ['error'] }),
    new Integrations.BrowserTracing(),
  ],
  environment: NODE_ENV || 'development',
  tracesSampleRate: 0.2,
})

const container = document.getElementById('root')
const root = createRoot(container)
root.render(<App />)
